import { useAppDispatch } from "src/redux/hooks";
import { getLatestConsultationRequest } from "src/redux/slices/appointmentsSlice";
import { LatestConsultationData } from "src/types/appointment.types";
import { setPlanPackageDurationRelId } from "src/redux/slices/appointmentsSlice";

export const useCheckForLatestConsultation = () => {
  const dispatch = useAppDispatch();

  const checkForLatestConsultation = (
    planMasterId: string,
    planPackageDurationRelId: string,
    setIsPaidCoachLoading?: (isLoading: boolean) => void
  ) => {
    return new Promise((resolve, reject) => {
      dispatch(
        getLatestConsultationRequest({
          resolve,
          reject,
          payload: {
            planMasterId,
            planPackageDurationRelId,
          },
        })
      );
    })
      .then((res: any) => {
        const latestConsultationData: LatestConsultationData["latestPlan"] =
          res?.data?.latestPlan;
        const {
          payment_status,
          slot_booking_process,
          purchase_amount,
          plan_package_duration_rel_id,
          patient_plan_rel_id,
        } = latestConsultationData ?? {};

        if (plan_package_duration_rel_id) {
          dispatch(setPlanPackageDurationRelId(plan_package_duration_rel_id));
        }

        return {
          payment_status,
          slot_booking_process,
          purchase_amount,
          plan_package_duration_rel_id,
          patient_plan_rel_id,
        };
      })
      .catch((error) => {
        console.error("Error fetching latest consultation:", error);
      })
      .finally(() => {
        setIsPaidCoachLoading?.(false);
      });
  };

  return { checkForLatestConsultation };
};
